// extracted by mini-css-extract-plugin
export default {"templateName":"templateName--r_63e","chosenTemplate":"chosenTemplate--ImxaH"};